/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { Button, Tabs, Select } from 'antd';
import { Widget } from 'datastake-daf/dist/components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { addedHeaderTypes, widgetTypes } from './config';
import { getPopupContainer } from '../../../helpers/popUp';

const emptyFunction = () => { };

const ProjectDashboardWidget = ({
  children = null,
  type = widgetTypes.DEFAULT,
  addedHeader = null,
  title = '',
  loading = false,
  fullWidgetLoading = false,
  header = null,
  tooltip,
  className,
  withBorderHeader = true,
}) => {
  const addedHeaderComponent = useMemo(() => {
    if (addedHeader) {
      switch (addedHeader.type) {
        case addedHeaderTypes.BUTTON:
          const props = addedHeader.props || {};
          const btnOnClick = addedHeader.onClick || emptyFunction;
          return (
            <Button {...props} onClick={btnOnClick}>
              {addedHeader.label}
            </Button>
          );
        case addedHeaderTypes.TABS:
          return (
            <Tabs
              defaultActiveKey={addedHeader.defaultActiveKey}
              onChange={addedHeader.onChange || emptyFunction}
              items={(addedHeader.tabs || []).map((t) => ({
                label: t.label,
                key: t.key
              }))}
            />
          );
        case addedHeaderTypes.SELECT:
          return (
            <div className={formatClassname([addedHeader.customClassname, 'select-cont'])}>
              <label>{addedHeader.label}</label>
              <div>
                <Select
                  {...getPopupContainer()}
                  defaultValue={addedHeader.defaultValue}
                  onChange={addedHeader.onChange || emptyFunction}
                  className="custom-select"
                >
                  {(addedHeader.options || []).map((o) => (
                    <Select.Option value={o.value} key={`${o.value}-${title}`}>
                      {o.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          );
        default:
          return null;
      }
    }
    return null;
  }, [addedHeader]);

  return (
    <Widget
      className={formatClassname([
        'widget',
        type,
        className,
        withBorderHeader && 'with-border-header',
      ])}
      loading={loading}
      fullWidgetLoading={fullWidgetLoading}
      title={title}
      tooltip={tooltip}
      addedHeader={!!header ? header : (addedHeader && !loading) ? (
        <div className="cont flex-1">
          {addedHeaderComponent}
        </div>
      ) : null}
    >
      {children}
    </Widget>
  );
}

export default ProjectDashboardWidget;
